import axios from "axios";
import { FETCH_VIDEO_MANAGER_QUEUE, interceptor, RETRY_VIDEO_MANAGER_QUEUE_ITEM } from ".";
import store from "../store";

interceptor(axios, store);

export function getVideoQueue() {
  return {
    type: FETCH_VIDEO_MANAGER_QUEUE,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/video_manager/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function retryVideoQueueItem(mRecordId) {
  return {
    type: RETRY_VIDEO_MANAGER_QUEUE_ITEM,
    payload: axios.put(
      `${process.env.REACT_APP_API_ENDPOINT}/core/video_manager/retry/${mRecordId}`,{},
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id,
        },
      }
    ),
  };
}
